import React, { useState } from 'react'

// material-ui components
import Button from '@mui/material/Button'
import MenuIcon from '@mui/icons-material/Menu'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

// local components
import NavStepper from './NavStepper'

const MobileNav = props => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <Button
        aria-controls='mobile-menu'
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MenuIcon htmlColor='white' />
      </Button>
      <Menu
        id='mobile-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <NavStepper orientation='vertical' {...props} />
        </MenuItem>
      </Menu>
    </>
  )
}

export default MobileNav
